<template>
  <div :style=" dark ? 'background-color: black;' : 'background-color: white;' ">
      {{title}}
      <v-btn  v-if="addNew" @click="addItem()" color="primary" dark class="mb-2">New</v-btn>

    <!-- </v-toolbar> -->
    <!-- <v-btn primary>Add New</v-btn> -->
    <v-data-table
      id="simple-table"
      :hide-actions="true"
      :headers="headers"
      :items="rows"
      item-key="value"
      :class="[tablecolor, 'commontable']"
      :pagination.sync="pagination"
    >

    <template slot="headers" slot-scope="props">
      <tr>
        <th v-for="h in headers" v-bind:key="h.text"
          :align="h.align || 'left'"
        >
      <span><font size="-0.5">{{h.text}}</font></span>
      </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr @click="selectRow(props.item)">
        <td v-for="h in headers" :key="h.name"  :class="h.align === 'right' ? 'text-xs-right' : 'text-xs-left'">
            <div v-if="h.component === 'status'" style="padding-left: 10px">
              <CircleStatus :state="props.item[h.value]"></CircleStatus>
            </div>
            <div v-else>
              {{formatItem({i:props.item, h:h, e:stEditables, t:false})}}
            </div>
        </td>
      </tr> 
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2" v-if="pagination.totalItems > 10">
      <v-layout row wrap>
        <!-- <v-label style="padding-left:20px;">Items per page</v-label> -->
        <v-flex md1 lg1 sm4 style="padding-left:20px;">
          <v-select
          dense
          solo
          :label="'Rows per Page'"
          :items="[10,20,30]"
          v-model="pagination.rowsPerPage"
          ></v-select>
        </v-flex>
        <v-flex md11 lg11 sm8>
          <v-pagination 
            v-model="pagination.page" 
            :length="pages"
            :circle="true"
          >
          </v-pagination>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import utils from '../helpers/utils'
import CircleStatus from '../library/circleStatus'

export default {
  components: {
    CircleStatus
  },
  data: () => ({
    page: 1,
    pagination: {
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    }
  }),
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    dark: sync('misc/dark'),
    addNew: sync('stRowAddFunction'),
    title: sync('stTableTitle'),
    tableName: sync('stTableName'),
    headers: sync('stTableHeaders'),
    rows: sync('stTableRows'),
    rowClickFunction: sync('stRowClickFunction'),
    stEditables: sync('stEditables'),
    tablecolor: function () {
      if (this.dark) return 'simpledark'
      return 'simplelight'
    }
  },
  filters: {
    cellFilter: utils.cellFilter
  },
  watch: {
    rows: {
      immediate: true,
      handler (val) {
        this.pagination.totalItems = val.length
      }
    }
  },
  methods: {
    formatItem (obj) {
      let ret = utils.formatItem(obj)
      // console.log('simpleTable format item: ', obj, ret)
      return ret
    },
    selectRow (val) {
      if (this.rowClickFunction) {
        this.rowClickFunction(val)
      }
    },
    addItem () {
      if (this.addNew) {
        this.addNew()
      }
    }
  },
  mounted () {

  },
  beforeDestroy () {

  }
}
</script>

<style scoped>
#simple-table {
  margin-top: 0px;
  padding-top: 0px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: px;
  padding-bottom: 7px;
}

.headercolor {
  color: rgb(24, 176, 226);
  height: 30px;
  padding-left: 10px;
  padding-right: 2rem;
}
#simple-table table.v-table tbody td {
  height: 30px;
  padding-left: 10px;
  padding-right: 2rem;
}
#simple-table .v-table thead tr th{
  height: 2rem;
  padding-left: 10px;
  padding-right: 2rem;
  margin: 2px;
}
</style>
